// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__5GJnE","table":"Table_table__KuMFW","noDataCell":"Table_noDataCell__bCLH5"};